var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "dl",
      { staticClass: "row card-title" },
      [
        _vm._l(_vm.overige.rekening, function(rekening, index) {
          return [
            _c(
              "dt",
              {
                key: "dt-rekening-iban-" + parseInt(index),
                staticClass: "col-sm-3"
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.overige.rekening.length != 1
                        ? _vm.labels.rekening.iban + " " + (parseInt(index) + 1)
                        : _vm.labels.rekening.iban
                    ) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "dd",
              { key: "rekening-iban-" + index, staticClass: "col-sm-9" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.formatIBAN(rekening.iban)) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            rekening.bic
              ? [
                  _c(
                    "dt",
                    {
                      key: "dt-rekening-bic-" + parseInt(index),
                      staticClass: "col-sm-3"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.overige.rekening.length !== 1
                              ? _vm.labels.rekening.bic +
                                  " " +
                                  (parseInt(index) + 1)
                              : _vm.labels.rekening.bic
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "dd",
                    { key: "rekening-bic-" + index, staticClass: "col-sm-9" },
                    [
                      _vm._v(
                        "\n          " + _vm._s(rekening.bic) + "\n        "
                      )
                    ]
                  )
                ]
              : _vm._e()
          ]
        }),
        _vm._v(" "),
        !_vm.hiddenFieldsMap.rijbewijs
          ? [
              _c("dt", { staticClass: "col-sm-3" }, [
                _vm._v(_vm._s(_vm.labels.rijbewijs))
              ]),
              _vm._v(" "),
              _c("dd", { staticClass: "col-sm-9" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.overige.mobiliteit.rijbewijs ? "Ja" : "Nee") +
                    "\n      "
                )
              ])
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("dt", { staticClass: "col-sm-3" }, [
          _vm._v(_vm._s(_vm.labels.nummerplaten))
        ]),
        _vm._v(" "),
        _c("dd", { staticClass: "col-sm-9" }, [
          _vm._v(
            _vm._s(
              _vm.overige.mobiliteit.nummerplaten
                .map(function(x) {
                  return x.nummerplaat
                })
                .join(", ")
            )
          )
        ]),
        _vm._v(" "),
        !_vm.hiddenFieldsMap.orcid
          ? [
              _c("dt", { staticClass: "col-sm-3" }, [
                _vm._v(_vm._s(_vm.labels.orcid))
              ]),
              _vm._v(" "),
              _c("dd", { staticClass: "col-sm-9" }, [
                _vm._v(_vm._s(_vm.overige.orcid))
              ])
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }